import { makeAutoObservable } from "mobx";
import config from "../config";
import $api from "../http";
import { Master, Order, Service, User } from "../types";

export default class Store {
  isAuth: boolean = false;
  user: User = {} as User;
  masters: Master[] | null = null;
  order: Order = {} as Order;
  services: Service[] | null = null;
  products: Service[] | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setAuth(authed: boolean) {
    this.isAuth = authed;
  }

  setUser(user: User) {
    this.user = user;
  }

  uploadData() {
    $api.get(`${config.API}/auth/check?t=${localStorage.token}`).then(({ data }) => {
      if (data.status === "error") return this.setAuth(false);
      if (data.status === "success" && data.data) {
        this.setAuth(true);
        this.setUser(data.data);
        return this.setAuth(true);
      }
    });
  }

  setMasters(masters: Master[]) {
    this.masters = masters;
  }

  setSelectedMaster(master: Master) {
    this.order.master = master;
  }

  setServices(services: Service[]) {
    this.services = services;
  }

  setProducts(products: Service[]) {
    this.products = products;
  }

  setSelectedServices(services: Service[]) {
    this.order.services = services;
  }

  setSelectedProducts(products: Service[]) {
    this.order.products = products;
  }

  setSelectedPhone(phone: string) {
    this.order.phone = phone;
  }
  
  setClientName(name: string) {
    this.order.name = name;
  }

  setJoins(count: number) {
    this.order.joins = count;
  }
}
